module.exports = __webpack_public_path__ + "static/img/年度最佳智驾系统.52371fa0.png";